import * as types from '../actions/_actionTypes';
import initialState from './_initialReducerState'

export default function VerumReducer(state = initialState.verum, action: any) {
  switch (action.type) {

    case types.SAVE_VERUM_SUCCESS:
      return action.verum;

    default:
      return state;
  }
}
